module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-top-backplates.13d94e99.png";